var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-field',{staticClass:"has-margin-top-50",attrs:{"label":_vm.$t('_.code'),"vname":_vm.$t('_.code')
      .toString()
      .toLowerCase(),"vid":"code"}},[_c('b-input',{attrs:{"value":_vm.value,"disabled":_vm.isDisabled,"placeholder":_vm.$t('_.code'),"name":"code"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }